// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as V2i$Linear from "lumi-linear/lib/es6/src/V2i.res.js";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";
import * as PlaceClass$LumiDocuments from "./PlaceClass.res.js";
import * as PlaceModel$LumiDocuments from "./PlaceModel.res.js";
import * as RightAngle$LumiDocuments from "./Types/RightAngle.res.js";

let jsonCodec = Jzon.object5(param => [
  param.occupationKey,
  param.imgResolution,
  param.imgRotation,
  param.placeClass,
  param.placeModel
], param => ({
  TAG: "Ok",
  _0: {
    occupationKey: param[0],
    imgResolution: param[1],
    imgRotation: param[2],
    placeClass: param[3],
    placeModel: param[4]
  }
}), Jzon.field("occupationKey", Document$LumiStore.Key.jsonCodec()), Jzon.field("imgResolution", V2i$Linear.jsonCodec), Jzon.field("imgRotation", RightAngle$LumiDocuments.RightAngle.jsonCodec), Jzon.field("placeClass", PlaceClass$LumiDocuments.PlaceClass.jsonCodec), Jzon.field("placeModel", PlaceModel$LumiDocuments.jsonCodec));

export {
  jsonCodec,
}
/* jsonCodec Not a pure module */
